import { render, staticRenderFns } from "./FeatureTourSlides.vue?vue&type=template&id=55189ad8&scoped=true"
import script from "./FeatureTourSlides.vue?vue&type=script&lang=js"
export * from "./FeatureTourSlides.vue?vue&type=script&lang=js"
import style0 from "./FeatureTourSlides.vue?vue&type=style&index=0&id=55189ad8&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55189ad8",
  null
  
)

export default component.exports